@if (isOpen) {
  <!-- Backdrop -->
  <div class="reminders-backdrop" [@fadeIn] (click)="onBackdropClick()">
  </div>
  <!-- Panel -->
  <div class="reminders-panel" [@slideDown]>
    <!-- Header -->
    <div class="reminders-header">
      <div class="reminders-header-top">
        <div class="reminders-header-left">
          <div class="reminders-icon-container">
            <mat-icon class="calender_icon text-white">alarm</mat-icon>
          </div>
          <div>
            <h3 class="reminders-header-title">Reminders</h3>
            @if (filteredReminders$ | async; as reminders) {
              <p class="reminders-active-count">
                {{ reminders.length }} active
              </p>
            }
          </div>
        </div>
        <button class="reminders-close-btn" (click)="onClose.emit()" aria-label="Close reminders panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <!-- Stats -->
      @if (stats$ | async; as stats) {
        <div class="reminders-stats">
          <div class="reminders-stat-card">
            <div class="reminders-stat-header">
              <mat-icon class="text-white">warning</mat-icon>
              <span class="reminders-stat-label">Overdue</span>
            </div>
            <div class="reminders-stat-value">{{ stats.overdueCount }}</div>
          </div>
          <div class="reminders-stat-card">
            <div class="reminders-stat-header">
              <mat-icon class="text-white">calendar_today</mat-icon>
              <span class="reminders-stat-label">Today</span>
            </div>
            <div class="reminders-stat-value">{{ stats.todayCount }}</div>
          </div>
          <div class="reminders-stat-card">
            <div class="reminders-stat-header">
              <mat-icon class="text-white">trending_up</mat-icon>
              <span class="reminders-stat-label">Later</span>
            </div>
            <div class="reminders-stat-value">{{ stats.laterCount }}</div>
          </div>
        </div>
      }
    </div>
    <!-- Filter Bar -->
    <div class="reminders-filter-bar">
      <div class="reminders-filter-buttons">
        <button class="reminders-filter-btn" [class.active]="filterType === 'all'" (click)="onFilterChange('all')">
          All
        </button>
        <button class="reminders-filter-btn" [class.active]="filterType === 'meeting'"
          (click)="onFilterChange('meeting')">
          Meetings
        </button>
        <button class="reminders-filter-btn" [class.active]="filterType === 'deadline'"
          (click)="onFilterChange('deadline')">
          Deadlines
        </button>
      </div>
      <!-- Status Dropdown -->
      <div class="reminders-status-dropdown-wrapper">
        <button #statusDropdownBtn class="reminders-status-dropdown-btn" (click)="toggleStatusDropdown()"
          aria-label="Filter by status">
          <span>{{ getCurrentStatusLabel() }}</span>
          <mat-icon class="dropdown-arrow">{{ statusDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </div>
    <!-- Status Dropdown Menu - Rendered outside with fixed positioning -->
    @if (statusDropdownOpen) {
      <div class="reminders-status-dropdown-menu-overlay"
        [style.top.px]="statusDropdownPosition.top"
        [style.left.px]="statusDropdownPosition.left"
        (click)="$event.stopPropagation()">
        @for (option of statusOptions; track option) {
          <button
            class="status-option"
            [class.active]="filterStatus === option.value"
            (click)="onStatusChange(option.value)">
            <span class="status-radio" [class.checked]="filterStatus === option.value"></span>
            <span>{{ option.label }}</span>
          </button>
        }
      </div>
    }
    <!-- Reminders List -->
    <div class="reminders-list">
      <!-- Loading State -->
      @if (loading$ | async) {
        <div class="reminders-loading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      }
      @if (!(loading$ | async)) {
        @if (filteredReminders$ | async; as reminders) {
          <!-- Empty State -->
          @if (reminders.length === 0) {
            <div class="reminders-empty-state">
              <div class="reminders-empty-icon">
                <mat-icon>check</mat-icon>
              </div>
              <h4 class="reminders-empty-title">All caught up!</h4>
              <p class="reminders-empty-text">
                No {{ filterType !== 'all' ? filterType : '' }} reminders at the moment.
              </p>
              <button class="btn-add-reminder" (click)="onAddReminder()">
                <mat-icon>add</mat-icon>
                Add Reminder
              </button>
            </div>
          }
          <!-- Reminder Cards -->
          @if (reminders.length > 0) {
            <div class="reminders-cards">
              @for (reminder of reminders; track trackByReminderId(i, reminder); let i = $index) {
                <app-reminder-card
                  [reminder]="reminder" [snoozeOpen]="snoozeOpenId === reminder.id" [style.animation-delay]="(i * 0.05) + 's'"
                  [@slideIn] (onSnooze)="onSnooze($event)" (onDismiss)="onDismiss($event)" (onComplete)="onComplete($event)"
                  (onSnoozeToggle)="onSnoozeToggle($event)" (onEdit)="onEditReminder($event)"
                  (onNavigate)="onClose.emit()">
                </app-reminder-card>
              }
            </div>
          }
        }
      }
    </div>
    <!-- Footer -->
    @if ((filteredReminders$ | async)?.length) {
      <div class="reminders-footer">
        <div class="reminders-footer-actions">
          <button class="btn-add-new" (click)="onAddReminder()">
            <mat-icon>add</mat-icon>
            Add New
          </button>
          <button class="btn-dismiss-all" (click)="onDismissAll()">
            Dismiss all
          </button>
        </div>
      </div>
    }
  </div>
}